<div
  class="search-palette-container"
  [ngClass]="{ 'dark-theme': _isDarkTheme, 'light-theme': _isLightTheme, 'paper-theme': _isPaperTheme }"
>
  <!-- Search Input Section -->
  <div class="search-input-section">
    <mat-form-field class="search-input-field" appearance="fill">
      <mat-label>Search everything...</mat-label>
      <input
        #searchInput
        autocomplete="off"
        matInput
        placeholder="Search words, pairs, dictionaries, users..."
        [(ngModel)]="_searchTerm"
        (ngModelChange)="onSearchChange($event)"
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>

  <!-- Results Summary -->
  <div
    class="results-summary"
    *ngIf="!_loading && _searchTerm && _searchTerm.length >= 2 && getTotalResultsCount() > 0"
  >
    <div class="summary-item" *ngIf="getResultCount('Word') > 0">
      <span class="count">{{ getResultCount('Word') }}</span>
      <span class="label">{{ getResultCount('Word') === 1 ? 'word' : 'words' }}</span>
    </div>
    <div class="summary-item" *ngIf="getResultCount('Pair') > 0">
      <span class="count">{{ getResultCount('Pair') }}</span>
      <span class="label">{{ getResultCount('Pair') === 1 ? 'pair' : 'pairs' }}</span>
    </div>
    <div class="summary-item" *ngIf="getResultCount('Dictionary') > 0">
      <span class="count">{{ getResultCount('Dictionary') }}</span>
      <span class="label">{{ getResultCount('Dictionary') === 1 ? 'dictionary' : 'dictionaries' }}</span>
    </div>
    <div class="summary-item" *ngIf="getResultCount('User') > 0">
      <span class="count">{{ getResultCount('User') }}</span>
      <span class="label">{{ getResultCount('User') === 1 ? 'user' : 'users' }}</span>
    </div>
    <div class="summary-item" *ngIf="getResultCount('Note') > 0">
      <span class="count">{{ getResultCount('Note') }}</span>
      <span class="label">{{ getResultCount('Note') === 1 ? 'note' : 'notes' }}</span>
    </div>
    <div class="summary-item" *ngIf="getResultCount('Quiz') > 0">
      <span class="count">{{ getResultCount('Quiz') }}</span>
      <span class="label">{{ getResultCount('Quiz') === 1 ? 'quiz' : 'quizzes' }}</span>
    </div>
    <div class="summary-item" *ngIf="getResultCount('Figure') > 0">
      <span class="count">{{ getResultCount('Figure') }}</span>
      <span class="label">{{ getResultCount('Figure') === 1 ? 'figure' : 'figures' }}</span>
    </div>
  </div>

  <!-- Search Tabs -->
  <div class="search-tabs">
    <button class="search-tab" [class.active]="_selectedType?.raw_value === 'All'" (click)="selectType('All')">
      <mat-icon class="tab-icon">select_all</mat-icon>
      <span class="tab-label">All</span>
    </button>

    <button class="search-tab" [class.active]="_selectedType?.raw_value === 'User'" (click)="selectType('User')">
      <mat-icon class="tab-icon">person</mat-icon>
      <span class="tab-label">Users</span>
    </button>

    <button class="search-tab" [class.active]="_selectedType?.raw_value === 'Word'" (click)="selectType('Word')">
      <mat-icon class="tab-icon">fiber_manual_record</mat-icon>
      <span class="tab-label">Words</span>
    </button>

    <button class="search-tab" [class.active]="_selectedType?.raw_value === 'Pair'" (click)="selectType('Pair')">
      <mat-icon class="tab-icon">fiber_smart_record</mat-icon>
      <span class="tab-label">Pairs</span>
    </button>

    <button
      class="search-tab"
      [class.active]="_selectedType?.raw_value === 'Dictionary'"
      (click)="selectType('Dictionary')"
    >
      <mat-icon class="tab-icon">auto_stories</mat-icon>
      <span class="tab-label">Dictionaries</span>
    </button>

    <button class="search-tab" [class.active]="_selectedType?.raw_value === 'Note'" (click)="selectType('Note')">
      <mat-icon class="tab-icon">text_snippet</mat-icon>
      <span class="tab-label">Notes</span>
    </button>

    <button class="search-tab" [class.active]="_selectedType?.raw_value === 'Quiz'" (click)="selectType('Quiz')">
      <mat-icon class="tab-icon">question_answer</mat-icon>
      <span class="tab-label">Quizzes</span>
    </button>

    <button class="search-tab" [class.active]="_selectedType?.raw_value === 'Figure'" (click)="selectType('Figure')">
      <mat-icon class="tab-icon">hub</mat-icon>
      <span class="tab-label">Figures</span>
    </button>
  </div>

  <!-- Search Results Container -->
  <div class="search-results-container">
    <!-- Initial State (no search term) -->
    <div class="initial-state" *ngIf="!_searchTerm || _searchTerm.length < 2">
      <mat-icon>search</mat-icon>
      <h3>Search in Daydic</h3>
      <p>Start typing to search across all learning elements</p>
      <div class="search-tips">
        <div class="tip"><kbd style="color: gray">↑</kbd><kbd style="color: gray">↓</kbd> Navigate</div>
        <div class="tip"><kbd style="color: gray">Enter</kbd> Select</div>
        <div class="tip"><kbd style="color: gray">Esc</kbd> Close</div>
      </div>
    </div>

    <!-- Loading State -->
    <div class="loading-state" *ngIf="_loading && _searchTerm && _searchTerm.length >= 2">
      <mat-spinner diameter="24"></mat-spinner>
      <span>Searching...</span>
    </div>

    <!-- Results List -->
    <div class="results-list" *ngIf="!_loading && _searchTerm && _searchTerm.length >= 2 && hasResults()">
      <!-- Word Results -->
      <div
        class="result-item"
        *ngFor="let item of getCurrentResults(); let i = index"
        tabindex="0"
        [class.highlighted]="isRowHighlighted(i)"
        [class.selected]="isRowSelected(i)"
        (click)="selectResult(i)"
        (keydown.enter)="selectResult(i)"
      >
        <div class="result-icon" *ngIf="item.type !== 'user'">
          <mat-icon>{{ getResultIcon(item.type) }}</mat-icon>
        </div>

        <div class="result-content">
          <div class="result-title">
            <!-- User Results -->
            <ddc-search-result-user
              *ngIf="item.type === 'user'"
              [_DefaultProfilePic]="_DefaultProfilePic"
              [result]="item"
              [showIcon]="false"
              [showTime]="false"
              (userClick)="navigateToUser($event)"
            >
            </ddc-search-result-user>

            <!-- Word Results -->
            <ddc-search-result-word
              *ngIf="item.type === 'word'"
              [result]="item"
              [showIcon]="false"
              [showTime]="true"
              (wordClick)="openReadWordDialog($event)"
            >
            </ddc-search-result-word>

            <!-- Pair Results -->
            <ddc-search-result-pair
              *ngIf="item.type === 'pair'"
              [result]="item"
              [showIcon]="false"
              [showTime]="true"
              (pairClick)="openReadPairDialog($event)"
            >
            </ddc-search-result-pair>

            <!-- Dictionary Results -->
            <ddc-search-result-dictionary
              *ngIf="item.type === 'dictionary'"
              [result]="item"
              [showIcon]="false"
              [showTime]="true"
              (dictionaryClick)="navigateToDictionary($event)"
            >
            </ddc-search-result-dictionary>

            <!-- Note Results -->
            <ddc-search-result-note
              *ngIf="item.type === 'note'"
              [result]="item"
              [showIcon]="false"
              [showTime]="true"
              (noteClick)="navigateToNote($event)"
            >
            </ddc-search-result-note>

            <!-- Quiz Results -->
            <ddc-search-result-quiz
              *ngIf="item.type === 'quiz'"
              [result]="item"
              [showIcon]="false"
              [showTime]="true"
              (quizClick)="navigateToQuiz($event)"
            >
            </ddc-search-result-quiz>

            <!-- Figure Results -->
            <ddc-search-result-figure
              *ngIf="item.type === 'figure'"
              [result]="item"
              [showIcon]="false"
              [showTime]="true"
              (figureClick)="navigateToFigure($event)"
            >
            </ddc-search-result-figure>
          </div>

          <div class="result-info">
            <!-- User Info -->
          </div>
        </div>

        <div class="result-time" *ngIf="item.time_since_creation">
          {{ item.time_since_creation }}
        </div>
      </div>

      <!-- See All Results Footer -->
      <div class="see-all-footer" *ngIf="getCurrentResults().length > 0" (click)="openAllResults()">
        <mat-icon>arrow_forward</mat-icon>
        <span>See all {{ getCurrentResults().length }} results</span>
      </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="!_loading && _searchTerm && _searchTerm.length >= 2 && !hasResults()">
      <mat-icon>search_off</mat-icon>
      <h3>No results found</h3>
      <p>Try searching with different keywords or check your spelling</p>
    </div>
  </div>
</div>
